import React, { useEffect, useState } from "react";
import axiosClient from "../../api/axiosClient";

export type StatCardProps = {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  className?: string;
  bg?: any; // tailwind background class (e.g. "bg-blue-50")
  iconbg?: string;
  iconcolor?: string;
};

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  className = "",
  iconbg = "bg-gray-50",
  iconcolor = "text-gray-50",
  bg,
}) => {
  return (
    <div
      className={` rounded-2xl p-4 shadow-sm flex items-start gap-4 overflow-hidden ${className}`}
      style={{ background: bg }}
    >
      <div className="flex-1">
        <div className="text-md font-semibold text-color">{title}</div>
        <div className="mt-2 text-xl font-bold text-color">{value}</div>
        {/* {subtitle && <div className="text-xs text-gray-400 mt-1">{subtitle}</div>} */}
      </div>
      <div className="flex-shrink-0">
        <div
          className={`w-12 h-12 rounded-2xl  flex items-center justify-center shadow ${iconbg} ${iconcolor}`}
        >
          {icon ?? <span className={` text-lg`}>📊</span>}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
